/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Report_Dealoutcome_Nodata3Inputs */

const en_coinvestments_report_dealoutcome_nodata3 = /** @type {(inputs: Coinvestments_Report_Dealoutcome_Nodata3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deal outcome data is not available.`)
};

/**
* | output |
* | --- |
* | "Deal outcome data is not available." |
*
* @param {Coinvestments_Report_Dealoutcome_Nodata3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_report_dealoutcome_nodata3 = /** @type {((inputs?: Coinvestments_Report_Dealoutcome_Nodata3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Report_Dealoutcome_Nodata3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_report_dealoutcome_nodata3(inputs)
});
export { coinvestments_report_dealoutcome_nodata3 as "coInvestments_report_dealOutcome_noData" }